import { getSession } from './auth.js';
import { get, post } from './api.js';

// The Me page renders with `data-pending` so nothing paints before the session
// is known (no flash of the account page on the way to the sign-up flow).
function revealMe() {
  var root = document.querySelector('.account-page[data-pending]');
  if (root) root.removeAttribute('data-pending');
}

function initDashboard() {
  var dashboard = document.getElementById('account-dashboard');
  var loading = document.getElementById('account-loading');
  if (!dashboard || dashboard._dashboardReady) return;
  dashboard._dashboardReady = true;
  var locale = dashboard.dataset.locale || 'en';
  var D = JSON.parse(dashboard.dataset.i18n || '{}');
  var STATUS = JSON.parse(dashboard.dataset.statusI18n || '{}');

  getSession().then(function (user) {

    if (!user) {
      // Site shell: nothing to show — send them into the sign-up flow.
      // App shell: there is no hamburger menu, so the account/settings rows here
      // are the only way to reach sign-in / settings.
      if (document.documentElement.dataset.shell === 'app') {
        var signedOut = document.getElementById('me-signed-out');
        if (signedOut) signedOut.hidden = false;
        revealMe();
        return;
      }
      // replace(), not href: /me/ must not sit in history — otherwise Back
      // returns to a page that only redirects again.
      window.location.replace('/' + locale + '/me/signup/');
      return;
    }

    if (dashboard) dashboard.hidden = false;
    revealMe();

    // Welcome — replace {name} placeholder
    var welcomeEl = document.getElementById('account-welcome');
    if (welcomeEl) {
      welcomeEl.textContent = welcomeEl.textContent.replace('{name}', user.name);
    }

    document.getElementById('profile-name').textContent = user.name;
    document.getElementById('profile-email').textContent = user.email;

    var adminCard = document.getElementById('account-admin');
    if (adminCard) adminCard.hidden = user.role !== 'admin';

    // Bookings
    get('/me/bookings').then(function (data) {
      function renderBookingRow(b) {
        var statusLabel = STATUS[b.status] || b.status;
        var actions = b.status === 'pending'
          ? '<button class="button button--small" data-cancel="' + b.id + '">' + (D.cancel || 'Cancel') + '</button>'
          : '';
        return { statusLabel: statusLabel, actions: actions };
      }

      if (data.bookings && data.bookings.length > 0) {
        document.getElementById('no-bookings').hidden = true;
        var wrapper = document.getElementById('bookings-table-wrapper');
        wrapper.hidden = false;

        // Desktop table
        var tbody = document.getElementById('bookings-body');
        tbody.innerHTML = '';
        // Mobile cards
        var mobileEl = document.getElementById('bookings-mobile');
        mobileEl.innerHTML = '';

        for (var i = 0; i < data.bookings.length; i++) {
          var b = data.bookings[i];
          var r = renderBookingRow(b);

          // Desktop row
          var tr = document.createElement('tr');
          tr.innerHTML = '<td>' + b.booking_date + '</td><td>' + b.booking_time + '</td><td>' + b.service + '</td><td>' + r.statusLabel + '</td><td>' + r.actions + '</td>';
          tbody.appendChild(tr);

          // Mobile card
          var card = document.createElement('div');
          card.className = 'account-booking-card';
          card.innerHTML = '<div class="account-booking-card__row"><span>' + (D.tableDate || 'Date') + '</span><span>' + b.booking_date + '</span></div>' +
            '<div class="account-booking-card__row"><span>' + (D.tableTime || 'Time') + '</span><span>' + b.booking_time + '</span></div>' +
            '<div class="account-booking-card__row"><span>' + (D.tableService || 'Service') + '</span><span>' + b.service + '</span></div>' +
            '<div class="account-booking-card__row"><span>' + (D.tableStatus || 'Status') + '</span><span>' + r.statusLabel + '</span></div>' +
            (r.actions ? '<div class="account-booking-card__row account-booking-card__row--actions">' + r.actions + '</div>' : '');
          mobileEl.appendChild(card);
        }
      } else {
        document.getElementById('no-bookings').hidden = false;
      }
    }).catch(function () {});

    // Cancel booking
    document.getElementById('bookings-body').addEventListener('click', function (e) {
      var cancelBtn = e.target.closest('[data-cancel]');
      if (!cancelBtn) return;
      var bookingId = cancelBtn.dataset.cancel;
      if (!confirm(D.cancelConfirm || 'Cancel this booking?')) return;
      post('/bookings/' + encodeURIComponent(bookingId) + '/cancel').then(function () {
        cancelBtn.closest('tr').querySelector('td:nth-child(4)').textContent = STATUS.cancelled || 'Cancelled';
        cancelBtn.remove();
      }).catch(function () { alert(D.cancelFailed || 'Could not cancel this booking.'); });
    });

    // Cancel from mobile card
    document.getElementById('bookings-mobile').addEventListener('click', function (e) {
      var cancelBtn = e.target.closest('[data-cancel]');
      if (!cancelBtn) return;
      var bookingId = cancelBtn.dataset.cancel;
      if (!confirm(D.cancelConfirm || 'Cancel this booking?')) return;
      post('/bookings/' + encodeURIComponent(bookingId) + '/cancel').then(function () {
        cancelBtn.closest('.account-booking-card').querySelector('.account-booking-card__row:nth-child(4) span:last-child').textContent = STATUS.cancelled || 'Cancelled';
        cancelBtn.remove();
      }).catch(function () { alert(D.cancelFailed || 'Could not cancel this booking.'); });
    });

    // Logout
    var logoutLink = document.getElementById('logout-link');
    if (logoutLink) {
      logoutLink.addEventListener('click', function (e) {
        e.preventDefault();
        post('/auth/signout').then(function () {
          window.location.href = '/' + locale + '/';
        });
      });
    }

    // Anonymize
    var anonymizeBtn = document.getElementById('anonymize-btn');
    var anonymizeForm = document.getElementById('anonymize-form');
    var anonymizeCancel = document.getElementById('anonymize-cancel');

    if (anonymizeBtn) {
      anonymizeBtn.addEventListener('click', function () {
        document.getElementById('anonymize-controls').hidden = true;
        anonymizeForm.hidden = false;
      });
    }

    if (anonymizeCancel) {
      anonymizeCancel.addEventListener('click', function () {
        anonymizeForm.hidden = true;
        document.getElementById('anonymize-controls').hidden = false;
      });
    }

    if (anonymizeForm) {
      anonymizeForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var submitBtn = anonymizeForm.querySelector('button[type="submit"]');
        var password = document.getElementById('anonymize-password').value;

        submitBtn.disabled = true;

        post('/me/anonymize', { password: password }).then(function () {
          window.location.href = '/' + locale + '/?anonymized=1';
        }).catch(function (err) {
          showToast((err && err.message) || D.error || 'Something went wrong', 'attention');
          submitBtn.disabled = false;
        });
      });
    }
  });
}

document.addEventListener('page:load', initDashboard);
